import React from "react";

import { trending } from "./Trendingarray";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useCart } from "react-use-cart";
import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  Box,
  Typography,
  CardMedia,
  Modal,
  Grid,
  Avatar,
  Button,
  Container,
} from "@mui/material";
const Trendingcard = (props) => {
  const [open, setOpen] = React.useState(false);
  const [selectedcloth, setSelectedcloth] = useState({});

  const handelOpen = (props) => {
    setOpen(true);
    setSelectedcloth(props);
  };

  const handelClose = () => setOpen(false);
  const closeModel = () => {
    setOpen(false);
  };
  const [color, setColor] = useState("");

  const handleChange = (event) => {
    setColor(event.target.value);
  };
  const [size, setSize] = useState("");
  const handleChangesize = (event) => {
    setSize(event.target.value);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (variant, item) => () => {
    if (color && size) {
      const newItem = {
        id: generateUniqueId(),
        name: props.name,
        image: props.img,
        quantity: props.quantity,
        price: props.price,
        color: color,
        size: size,
      };

      setColor("");
      setSize("");
      setOpen(false);
      addItem(newItem);
      enqueueSnackbar(`${newItem.name} cloth was added to cart`, { variant });
    } else {
      alert("Please select color and size.");
    }
  };

  const { addItem } = useCart();
  const generateUniqueId = () => {
    return Math.random().toString(36).substr(2, 9);
  };

  return (
    <React.Fragment>
      <Container>
        {" "}
        <Box
          boxShadow={24}
          sx={{
            border: "1px solid gray",
            borderRadius: "25px",
            marginTop: 4,
            borderRight: "5px solid #1a193a",
            borderBottom: "5px solid #1a193a",
            padding: 1,
          }}
          maxHeight="500px"
          maxWidth="310px"
         
        >
          <CardMedia
            component="img"
            src={props.img}
            height={250}
            boxShadow={5}
            sx={{
              borderRadius: "20px",
              display: "block",

              cursor: "pointer",
              ":hover": {
                transition: "0.3s",
                transform: "scale(1.05)",
              },
            }}
          />
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.2rem",
              fontWeight: "bold",
              mt: 2,
            }}
          >
            {props.name}
          </Typography>
          <Box sx={{ display: "flex", mb: 3, mt: 2 }}>
            <Typography sx={{ marginLeft: "auto", marginRight: 4 }}>
              Price: Rs{props.price}
            </Typography>

            <AddShoppingCartIcon
              sx={{
                marginRight: 3,
                cursor: "pointer",
                ":hover": {
                  transition: "0.3s",
                  transform: "scale(1.25)",
                },
              }}
              onClick={handelOpen}
            />
          </Box>
        </Box>
        <Modal open={open} onClose={handelClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              bgcolor: "background.paper",
              transform: "translate(-50%,-50%)",
              width: { lg: 600, xs: 290, sm: 600, md: 700 },
              boxShadow: 24,
              p: 4,
              borderRadius: 10,
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                {props.name}
              </Typography>
              <Box
                sx={{
                  marginLeft: "auto",
                  cursor: "pointer",
                  ":hover": {
                    transition: "0.3s",
                    transform: "scale(1.1)",
                  },
                }}
                onClick={closeModel}
              >
                {" "}
                <CloseIcon />
              </Box>
            </Box>
            <Grid container spacing={5}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                {" "}
                <CardMedia
                  component="img"
                  src={props.img}
                  sx={{
                    mt: 5,
                    height: { lg: 400, xs: 200, md: 400, sm: 350 },
                    boxShadow: 24,
                    borderRadius: 5,
                  }}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                {" "}
                <Box sx={{ mt: { lg: 5, md: 5, sm: 5 }, mb: 5 }}>
                  <Typography sx={{ fontSize: "1.2rem" }}>
                    {props.description}
                  </Typography>
                  <Typography
                    sx={{ mt: 0.5, fontSize: "1.2rem", color: "red" }}
                  >
                    Price:{props.price}
                  </Typography>
                  <Typography sx={{ mt: 0.5 }}>Brand: {props.brand}</Typography>

                  <Typography sx={{ mb: 0.5 }}>Available Color:</Typography>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">color</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={color}
                      label="color"
                      onChange={handleChange}
                    >
                      <MenuItem value={props.color1}>{props.color1}</MenuItem>
                      <MenuItem value={props.color2}>{props.color2}</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography sx={{ mb: 0.5 }}>Size:</Typography>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Size</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={size}
                      label="size"
                      onChange={handleChangesize}
                    >
                      <MenuItem value={props.size1}>{props.size1}</MenuItem>
                      <MenuItem value={props.size2}>{props.size2}</MenuItem>
                      <MenuItem value={props.size3}>{props.size3}</MenuItem>
                      <MenuItem value={props.size4}>{props.size4}</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    onClick={handleClickVariant("success", props.item)}
                    variant="contained"
                    sx={{
                      position: "absolute",
                      bottom: { lg: 40, xs: 20, sm: 40, md: 40 },
                      right: 120,
                      bgcolor: "#022a6b",
                      ":hover": {
                        transition: "0.3s",
                        transform: "scale(1.1)",
                        color: "#022a6b",
                        bgcolor: "white",
                      },
                    }}
                  >
                    Add to cart
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default Trendingcard;
